// extracted by mini-css-extract-plugin
export default {"root":"IconIntercom_root__2rkOK"};